import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import HotelViewVue from "@/views/HotelView.vue";
import AccommodationViewVue from "@/views/AccommodationView.vue";
import PensionViewVue from "@/views/PensionView.vue";
import FlightDepartureViewVue from "@/views/FlightDepartureView.vue";
import TransferViewVue from "@/views/TransferView.vue";
import PersonalDataViewVue from "@/views/PersonalDataView.vue";
import PersonalDataOverviewViewVue from "@/views/PersonalDataOverviewViewVue.vue";
import BookingConfirmationViewVue from "@/views/BookingConfirmationView.vue";
import TravelOverviewView from "@/views/TravelOverviewView.vue";
import { App } from "vue";
import { Store  } from "vuex";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/hotel",
    name: "hotel",
    component: HotelViewVue,
  },
  {
    path: "/accommodation",
    name: "accommodation",
    component: AccommodationViewVue,
  },
  {
    path: "/pension",
    name: "pension",
    component: PensionViewVue,
  },
  {
    path: "/departure",
    name: "departure",
    component: FlightDepartureViewVue,
  },
  {
    path: "/transfer",
    name: "transfer",
    component: TransferViewVue,
  },
  {
    path: "/personal-data",
    name: "personal-data",
    component: PersonalDataViewVue,
  },
  {
    path: "/personal-data-overview",
    name: "personal-data-overview",
    component: PersonalDataOverviewViewVue,
  },
  {
    path: "/booking-confirmation",
    name: "booking-confirmation",
    component: BookingConfirmationViewVue,
  },
  {
    path: "/travel-overview",
    name: "travel-overview",
    component: TravelOverviewView,
  },
];

const routerInit = (app: App, store: Store<any>) => {
  const router = createRouter({
    history: createWebHashHistory(),
    routes,
  });

  router.beforeEach((to, from) => {
    if (to.name === "hotel" || to.name === undefined) {
      document.getElementById("bookingApp")?.classList.add("showHotel");
      document.body.classList.remove("no-nav");
    } else {
      document.getElementById("bookingApp")?.classList.remove("showHotel");
      document.body.classList.add("no-nav");
    }
    if(to.name ==="personal-data" && from.name !== "personal-data-overview") {
      store.dispatch('ApplicationModule/resetPersonalDataIndex');
    }
    store.dispatch('ApplicationModule/updateCurrentViewName', to.name);
  });

  app.use(router);

}

export default routerInit;